import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-deb30d62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "append-filters__container q-container-fluid q-pb-2 q-col-12 q-col-sm-6 q-col-md-3 q-d-block q-d-md-none q-pb-3 q-px-3 q-pb-sm-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString('Pokaż produkty'), -1))
const _hoisted_3 = {
  key: 0,
  class: "q-spinner-border q-spinner-border-sm q-ms-2",
  role: "status",
  "aria-hidden": "true"
}

import {inject} from "vue";
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";

import {SmartSearchTranslationsInterface} from "@/core/types";
import {storeToRefs} from "pinia";
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion

export default /*#__PURE__*/_defineComponent({
  __name: 'AppendFiltersButton',
  setup(__props) {

const filtersStore = useFiltersStore();
const serpStore = useSerpResultsStore()
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!

const {isMobileView, isLoading} = storeToRefs(filtersStore)
const {loading: productIsLoading} = storeToRefs(serpStore)

const appendFilters = () => {
  filtersStore.hideFiltersOnMobile()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "q-btn q-btn q-btn-danger q-rounded-3 q-shadow-sm",
      onClick: appendFilters
    }, [
      _hoisted_2,
      (_unref(isLoading) || (_unref(productIsLoading) && _unref(isMobileView)))
        ? (_openBlock(), _createElementBlock("span", _hoisted_3))
        : _withDirectives((_openBlock(), _createElementBlock("span", { key: 1 }, " (" + _toDisplayString(_unref(serpStore).getTotalProducts) + ")", 513)), [
            [_vShow, _unref(serpStore).getTotalProducts]
          ])
    ])
  ]))
}
}

})